module.exports = __webpack_public_path__ + "static/media/product-list-empty-state.6ad486fe.svg";